<template>
  <v-navigation-drawer
    v-model="drawer.model"
    :clipped="drawer.clipped"
    :floating="drawer.floating"
    :mini-variant="drawer.mini"
    :permanent="drawer.type === 'permanent'"
    :temporary="drawer.type === 'temporary'"
    app
    overflow
  >
    <v-list>
      <v-list-item class="px-2">
        <!-- <v-list-item-avatar>
          <v-img src="https://randomuser.me/api/portraits/women/85.jpg"></v-img>
        </v-list-item-avatar>-->
        <v-list-item-content v-if="!drawer.mini">
          <v-list-item-title class="title">Klik BOS</v-list-item-title>
          <v-list-item-subtitle>Klinik Layanan Informasi & Konseling Dana Bantuan Operasional Sekolah</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click.stop="drawer.mini = !drawer.mini">
            <v-icon v-if="!drawer.mini">mdi-chevron-left</v-icon>
            <v-icon v-if="drawer.mini">mdi-chevron-right</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>

    <v-list nav dense>
      <template v-for="(route, idx) in routes">
        <template
          v-if="!!route.childs && ((!!route.rule && $acl.check(route.rule)) || !route.rule)"
        >
          <v-divider :key="`${idx}-${route.name}-divider`" />
          <v-subheader
            class="mt-4 text--disabled"
            :key="`${idx}-${route.name}`"
            v-if="!drawer.mini"
          >
            <v-icon small>{{ route.icon }}</v-icon>
            <span class="pl-2">
              {{
              route.name.toUpperCase()
              }}
            </span>
          </v-subheader>
          <template v-for="item in route.childs">
            <v-list-item
              v-if="$acl.check(item.rule)"
              :key="`${item.name}-${route.name}`"
              :to="item.path"
            >
              <v-list-item-icon :title="item.name">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="item.name" :title="item.name" />
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider :key="`${idx}-${route.name}-divider2`" />
        </template>

        <v-list-item v-else-if="$acl.check(route.rule)" :key="idx" :to="route.path">
          <v-list-item-icon v-if="!!route.icon" :title="route.name">
            <v-icon>{{ route.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="route.name" :title="route.name" />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<style lang="scss">
@import "~vuetify/src/styles/main.sass";

.v-navigation-drawer {
  &__content {
    scrollbar-width: thin;

    // track
    &::-webkit-scrollbar-track {
      background: #f0f0f0;
    }

    // handle
    &::-webkit-scrollbar-thumb {
      background: #cdcdcd;
      border-radius: 50px;
    }

    // scrollbar
    &::-webkit-scrollbar {
      width: 5px;
      background-color: #f0f0f0;
    }

    // handle on hover
    &::-webkit-scrollbar-thumb:hover {
      background: #a6a6a6;
    }
  }

  .v-list-item {
    &--link {
      opacity: 0.7;
      border-radius: 0px !important;
      margin-left: -8px;
      margin-right: -8px;
      padding-left: 16px;
      padding-right: 16px;

      &::before {
        margin-top: 10px;
        margin-bottom: 10px;
        width: 15px;
        left: -8px;
        border-radius: 0 5px 5px 0;
        color: #26c6da;
      }

      &:hover::before {
        opacity: 0.2;
      }

      &.v-list-item--active {
        opacity: 1;
        &:hover::before,
        &::before {
          opacity: 1;
        }
      }
    }
  }
}
</style>

<script>
import { mapState } from "vuex";
import logo from "@/assets/logo.jpg";
export default {
  data: () => ({
    logo,
    title: "SPITDA",
    subtext: "Sistem Pengawasan ITDA"
  }),
  computed: mapState({
    routes: state => state.layout.routes,
    drawer: state => state.layout.drawer
  }),
  mounted() {
    this.$log.todo([
      "Change color based on scss vuetify variable",
      "Apply form filter",
      "How to reset object"
    ]);
  }
};
</script>

